import React, {useState, useEffect} from 'react';

import InlineButton from './../../atoms/InlineButton/InlineButton';
import {VARIANT} from './../../atoms/Typography/Typography';
import Iconography, {ICON} from './../../atoms/Iconography/Iconography';

import './Homepage.css';

const Homepage = () => {
  const [colorClass, setColorClass] = useState('color-one');

  useEffect(() => {
    const currentColor = localStorage.getItem('homepageColor') || 'color-one';
    const colors = ['one', 'two', 'three', 'four', 'five', 'six'];
    const currentIndex = colors.indexOf(currentColor);
    const nextIndex = (currentIndex + 1) % colors.length;
    const nextColor = colors[nextIndex];
    localStorage.setItem('homepageColor', nextColor);
    setColorClass(nextColor);
  }, []);

  return (
    <>
      <div className={`page-home color-${colorClass}`}>
        {/* LEFT TEXT */}
        <div className="leftText">
          <div className="line">
            <a href="/esta-pasando">
              <InlineButton hideUnderline={true} variant={VARIANT.H2} withHover={true}>
                Está pasando
              </InlineButton>
            </a>
            <span className="number">01</span>
          </div>
          <div className="line">
            <a href="/nosotros">
              <InlineButton hideUnderline={true} variant={VARIANT.H2} withHover={true}>
                Humans Leading Data
              </InlineButton>
            </a>
            <span className="number">02</span>
          </div>
          <div className="line">
            <a href="https://tobeinb2b.lin3s.com/" target="_blank">
              <InlineButton hideUnderline={true} variant={VARIANT.H2} withHover={true}>
                ToBeInB2B
              </InlineButton>
            </a>
            <span className="number">03</span>
          </div>
        </div>

        {/* MENU */}
        <div className="menu">
          <a href="/proyectos">
            <InlineButton hideUnderline={true} variant={VARIANT.H6} withHover={true}>
              Proyectos
            </InlineButton>
          </a>
          <a href="/formacion">
            <InlineButton hideUnderline={true} variant={VARIANT.H6} withHover={true}>
              Formación
            </InlineButton>
          </a>
          <a href="/unete">
            <InlineButton hideUnderline={true} variant={VARIANT.H6} withHover={true}>
              Únete
            </InlineButton>
          </a>
          <a href="/contacto">
            <InlineButton hideUnderline={true} variant={VARIANT.H6} withHover={true}>
              Contacto
            </InlineButton>
          </a>
        </div>

        {/* BIG TITLE */}
        <Iconography className="bigTitle" icon={ICON.LIN3S} />

        {/* SOCIAL */}
        <div className="social">
          <a href="https://es.linkedin.com/company/lin3s" target="_blank">
            <InlineButton hideUnderline={true} variant={VARIANT.BODY} withHover={true}>
              LinkedIn
            </InlineButton>
          </a>
          <a href="https://www.instagram.com/_lin3s_/?hl=es" target="_blank">
            <InlineButton hideUnderline={true} variant={VARIANT.BODY} withHover={true}>
              Instagram
            </InlineButton>
          </a>
          <a href="https://www.youtube.com/channel/UCGos9Q9t2lFkvJuOQXR4N8Q" target="_blank">
            <InlineButton hideUnderline={true} variant={VARIANT.BODY} withHover={true}>
              Youtube
            </InlineButton>
          </a>
        </div>
      </div>
    </>
  );
};

export default React.memo(Homepage);
